if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]') && (this.form.querySelector('[name=id]').disabled = false);
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.productInfoComponent = this.closest('.product-info') || null;
        this.submitButton = this.querySelector('[type="submit"]');
        this.recipientForm = this.querySelector('recipient-form') || null;
        this.isGoToCheckout = this.getAttribute('data-is-go-checkout');
        this.discountCode = this.getAttribute('data-discount-code');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      checkSelectedVariants() {
        let variantInputs = document.querySelectorAll('variant-selects .input__wrapper');
        let selectedVariant = document.querySelector('variant-selects input:checked') || null;

        let isSelected = true;
        if (variantInputs.length > 1 && !selectedVariant) {
          isSelected = false;
        }

        return isSelected;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.isGoToCheckout) {
          await this.clearCart();
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const isVariantSelected = this.checkSelectedVariants();

        if (!isVariantSelected) {
          const variantSelects = this.closest('.product__section')?.querySelectorAll('variant-selects');

          variantSelects.forEach(variantSelect => {
            variantSelect?.classList.add('variant-not-selected');
          })
          variantSelects[0]?.scrollIntoView({ block: "center", behavior: "smooth" })
          return;
        }

        if (this.recipientForm && !this.recipientForm.validateEmails()) {
          this.recipientForm?.displayErrorMessage('', {'email-confirmation': ['Emails don`t match']})
          return;
        }

        document.dispatchEvent(new Event('theme:loading:start'))
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && this.isGoToCheckout !== 'true') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if(localStorage.getItem('first-visited-page')){
          formData.append('properties[_first_visited_page]', localStorage.getItem('first-visited-page'));
        }

        config.body = formData;

        try {
          const fetchResponse = await fetch(`${routes.cart_add_url}`, config);
          const response = await fetchResponse.json();

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            this.trackEvents();
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          this.error = false;

          if (this.isGoToCheckout) {
            const discountCode = window.subscriptionOptions?.landingDiscount || this.discountCode || window.subscriptionOptions?.discount_codes?.current_code || null;

            window.location.href = discountCode ? `/checkout?discount=${discountCode}` : '/checkout'
            return
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response)
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response)
            this.trackEvents();
            
            if (window.dynamicPricing?.enabled) {
              const cartResponse = await fetch(`${routes.cart_url}.js`);
              if (!cartResponse.ok) return;

              const cartData = await cartResponse.json();
              window.dynamicPricing.cart = cartData;

              document.dispatchEvent(new Event('dynamic-pricing:cart-update'));
              this.productInfoComponent?.setSelectorsAppearance();
            }
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          document.dispatchEvent(new Event('theme:loading:end'))
        }
      }

      trackEvents() {
        if (typeof klaviyoItem != 'undefined') klaviyo.push(['track', 'Added to Cart', klaviyoItem]);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'add_to_cart',
          'atc_value': (subscriptionOptions.currentRCType == 'autodeliver' ? subscriptionOptions.subscribe_price : subscriptionOptions.regular_price) / 100,
          'items': [{'id': `shopify_US_${subscriptionOptions.currentProductID}_${subscriptionOptions.currentVariantID}`,
          'google_business_vertical': 'retail'}]
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }


      clearCart() {
        return fetch('/cart/clear.js')
      }
    }
  );
}
